import {
  FDBodyText, FDBox, FDContentContainer, FDIcon, FDPaper, FDStack, FDTextButton,
} from '@facet-wealth/design';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';


export const HouseholdBalanceSheetPageEmptyState = (props) => {
  const { balanceSheetResource, onAddAccount, onAddRealAsset } = props;

  return (
    <FDContentContainer>
      <PageHeader title={balanceSheetResource.attr('name')} />
      <FDBox paddingY={4}>
        <FDStack direction={'row'} alignItems={'stretch'} justifyContent={'center'} spacing={4} wrap>
          {balanceSheetResource.withRelationship(fr.relationships.addAccounts.name, (rel) => {
            return (
              <FDPaper
                padding={4}
                flex={1}
              >
                <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={1}>
                  <FDIcon icon={'accountBalance'} size={'lg'} color="primary" />
                  <FDTextButton
                    label={'Add an account'}
                    onClick={() => onAddAccount(rel)}
                    {...dataAttrs('household-balance-sheet-empty-state-add-account-btn')}
                  />
                  <FDBodyText value={'Securely connect to your bank or brokerage account, or add it manually.'} size={'md'} align={'center'} />
                </FDStack>
              </FDPaper>
            );
          }, () => null)}

          {balanceSheetResource.withRelationship(fr.relationships.addRealAsset.name, (rel) => {
            return (
              <FDPaper padding={4} flex={1}>
                <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={1}>
                  <FDIcon icon={'homeWork'} size={'lg'} color="primary" />
                  <FDTextButton
                    label={'Add real asset'}
                    onClick={() => onAddRealAsset(rel)}
                    {...dataAttrs('household-balance-sheet-empty-state-add-real-asset-btn')}
                  />
                  <FDBodyText value={'Let us know what tangible items you own, such as cars, real estate, and jewelry.'} size={'md'} align={'center'} />
                </FDStack>
              </FDPaper>
            );
          }, () => null)}
        </FDStack>
      </FDBox>
    </FDContentContainer>
  );
};

HouseholdBalanceSheetPageEmptyState.defaultProps = {
};

HouseholdBalanceSheetPageEmptyState.propTypes = {
  balanceSheetResource: PropTypes.object.isRequired,
  onAddAccount: PropTypes.func.isRequired,
  onAddRealAsset: PropTypes.func.isRequired,
};
